import { colors } from '../../colors';
var address = {
  arrowColor: colors.dirtBrown,
  textColor: colors.metal,
  borderColor: colors.metal,
  backgroundColor: colors.powder
};
export default address;